import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listEnterprises, readableApiError } from '../../api/dashboard';
import './dashboard.css';

// 超管/admin 企业选择器：列全部企业，按形态分流（团队→班级列表 / 无团队→全员看板）。
export default function EnterpriseListPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    listEnterprises()
      .then(setData)
      .catch((err) => setError(readableApiError(err, '加载企业列表失败')));
  }, []);

  const openEnterprise = (ent) => {
    if (ent.classes_enabled) {
      navigate(`/dashboard/classes?enterprise=${ent.id}`, { state: { enterpriseName: ent.name } });
    } else {
      navigate(`/dashboard/enterprises/${ent.id}`);
    }
  };

  return (
    <div className="aiq-dash dash-page">
      <div className="dash-head">
        <h1 className="dash-h1">企业看板</h1>
        <p className="dash-sub">选择企业查看其团队 / 全员测评看板。</p>
      </div>

      {error && <div className="dash-card dash-card--error">{error}</div>}
      {!data && !error && <div className="dash-card">加载中...</div>}
      {data && data.results.length === 0 && (
        <div className="dash-card">
          <div style={{ fontWeight: 600, marginBottom: 6 }}>暂无企业</div>
          <div className="dash-mut">系统中还没有任何企业。</div>
        </div>
      )}
      {data && data.results.length > 0 && (
        <>
          <p className="dash-mut">共 {data.count ?? data.results.length} 家企业</p>
          <div className="dash-list">
            {data.results.map((ent) => (
              <button
                key={ent.id}
                type="button"
                className="dash-list-card dash-list-card--btn"
                onClick={() => openEnterprise(ent)}
              >
                <div>
                  <div className="dash-list-card__name">{ent.name}</div>
                  <div className="dash-mut">
                    {ent.industry || '未指定行业'}
                    <span
                      className={`dash-badge ${ent.is_active ? 'dash-badge--ok' : 'dash-badge--mut'}`}
                      style={{ marginLeft: 8 }}
                    >
                      {ent.is_active ? '已激活' : '待审核'}
                    </span>
                    <span className="dash-badge dash-badge--form" style={{ marginLeft: 6 }}>
                      {ent.classes_enabled ? '团队' : '无团队'}
                    </span>
                  </div>
                </div>
                <div>
                  <div className="dash-list-card__stat">
                    {ent.completed_count} / {ent.member_count}
                  </div>
                  <div className="dash-mut" style={{ textAlign: 'right' }}>已完成 / 总人数</div>
                </div>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
